import { AxiosResponse } from 'axios';
import { BaseResponse } from 'models/baseResponse';
import axiosClient from './aixosClient';

const url = 'AutoBankService.aspx';

export const AutoBankService = {
    getList: (): Promise<AxiosResponse<BaseResponse<any>>> => {
        return axiosClient.post(url, { flag: 'bankDepositAvailable', paymentType: 'AUTOBANK' });
    },
    createOrder: (payload = {}): Promise<AxiosResponse<BaseResponse<any>>> => {
        return axiosClient.post(url, { flag: 'createDepositOrder', ...payload });
    },
    getDetailOrder: (payload = {}): Promise<AxiosResponse<BaseResponse<any>>> => {
        return axiosClient.post(url, { flag: 'GetDepositDetail', ...payload });
    },
};

export default AutoBankService;
